type CompanySizeType = {
  name: string,
  value: string,
};

const COMPANY_SIZE_OPTIONS: Array<CompanySizeType> = [
  { name: '', value: '' },
  { name: '1-200', value: '1-200' },
  { name: '201-500', value: '201-500' },
  { name: '501-1,000', value: '501-1,000' },
  { name: '1,001-5,000', value: '1,001-5,000' },
  { name: '5,001-10,000', value: '5,001-10,000' },
  { name: '10,001+', value: '10,001+' },
];

export { COMPANY_SIZE_OPTIONS };
